import { render } from "./motion-setting.vue?vue&type=template&id=14d336aa&scoped=true&ts=true"
import script from "./motion-setting.vue?vue&type=script&lang=ts"
export * from "./motion-setting.vue?vue&type=script&lang=ts"

import "./motion-setting.vue?vue&type=style&index=0&id=14d336aa&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d336aa"]])

export default __exports__